import React from "react";

function PatientIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1388_2197)">
        <path
          d="M7.89062 2.5H11.1C10.8531 1.89062 10.4625 1.35938 9.96875 0.940625L7.89062 2.5ZM9.06875 0.36875C8.55625 0.13125 7.99062 0 7.39062 0C5.7125 0 4.275 1.03437 3.68125 2.5H6.225L9.06875 0.36875ZM7.39062 8C9.6 8 11.3906 6.20937 11.3906 4C11.3906 3.83125 11.3813 3.6625 11.3594 3.5H3.42188C3.4 3.6625 3.39062 3.83125 3.39062 4C3.39062 6.20937 5.18125 8 7.39062 8ZM4.26562 9.7625C3.9625 9.85938 3.66875 9.98125 3.39062 10.1281V16H8.00625L6.0625 12.7563L4.26562 9.7625ZM5.29688 9.5375L6.775 12H8.89062C10.2719 12 11.3906 13.1187 11.3906 14.5C11.3906 15.0625 11.2031 15.5813 10.8906 16H13.4625C13.975 16 14.3906 15.5844 14.3906 15.0719C14.3906 11.9937 11.8969 9.5 8.81875 9.5H5.9625C5.7375 9.5 5.51562 9.5125 5.29688 9.54062V9.5375ZM0.390625 15.0719C0.390625 15.5844 0.80625 16 1.31875 16H2.39062V10.7937C1.16875 11.8156 0.390625 13.3531 0.390625 15.0719ZM10.3906 14.5C10.3906 13.6719 9.71875 13 8.89062 13H7.375L9.15938 15.975C9.85938 15.85 10.3906 15.2375 10.3906 14.5Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1388_2197">
          <path d="M0.390625 0H14.3906V16H0.390625V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PatientIcon;
